import { create } from 'zustand';

type Role = 'member' | 'holder';

interface AppStore {
  activeRole: Role;
  setRole: (role: Role) => void;
}

export const useAppStore = create<AppStore>((set) => ({
  activeRole: 'member',
  setRole: (role) => set({ activeRole: role }),
}));
